// ブレイクポイント
const breakPoint = {
	sp: window.getComputedStyle(document.documentElement).getPropertyValue('--breakPointSp'),
	tabPc: window.getComputedStyle(document.documentElement).getPropertyValue('--breakPointTabPc')
};

// selectでURL切り替え
(function(){
	const select = document.querySelectorAll('.js-select-url');
	select.forEach((tgt) => {
		tgt.addEventListener('change', () => {
			document.location.href = tgt.options[tgt.selectedIndex].value;
		});
	});
})();

// Recaptcha v3
(function(){
	const form = document.querySelector('form[data-recaptcha-form]');
	if(!form) return;
	form.addEventListener('submit', onSubmit);
	function onSubmit(e) {
		e.preventDefault();
		grecaptcha.ready(function() {
			grecaptcha.execute('6LejII0gAAAAAEWIo-loExCVwfT7rHtDg4BWkoSd', {action: 'submit'}).then(function(token){
				var recaptchaToken = document.getElementById('recaptchaToken');
				recaptchaToken.value = token;
				form.submit();
			});
		});
	}
})();	

const serviceTab = (() => {
  const tabwrap = document.querySelector('.service-category__tab');
  const tabs = document.getElementsByClassName('service-category__tab__button');
  const bodys = document.getElementsByClassName('service-category__description');
	if(!tabwrap) return;
	// 初期位置設定
	const initialNumber = 0;
	tabs[initialNumber].querySelector('.d-tab').classList.add('-active');
	bodys[initialNumber].classList.add('is-show');
	// タブ切り替え
  for(let i = 0; i < tabs.length; i++) {
		tabs[i].addEventListener("click", tabSwitch, false);
  }
	function tabSwitch() {
		// ボタン
		const activeTab = tabwrap.querySelector('.-active');
		activeTab.classList.remove('-active');
		const nextTab = this.querySelector('.d-tab');
		nextTab.classList.add('-active');
		const activeNumber = Number(nextTab.dataset.tab);
		// コンテンツ	
		for(let i = 0; i < bodys.length; i++) {
			if(bodys[i].classList.contains('is-show')) {
				bodys[i].classList.remove('is-show');	
			}
			if(Number(bodys[i].dataset.tab) == activeNumber) {
				bodys[i].classList.add('is-show');	
			}
		}
	}
})();

// 入庫フォーム LINE連携
const reservationConnectLINE = (() => {
	const targetForm = $('.js-reservationForm');

	if(!targetForm.length) return;

	$(document).ready(function () {
		// 管理画面で確認したliffIdを挿入
		const liffId = "2000987623-PNOdnBbZ"; 
		initializeLiff(liffId);
	})

	function initializeLiff(liffId) {
		liff.init({
			liffId: liffId
		}).then(() => {
			initializeApp();
		}).catch((err) => {
			console.log('LIFF Initialization failed ', err);
		});
	}

	function sendText(text) {
		liff.sendMessages([{
			'type': 'text',
			'text': text
		}]).then(function () {
			liff.closeWindow();
		}).catch(function (error) {
			window.alert('Failed to send message ' + error);
		});
	}

	const params = (new URL(document.location)).searchParams;
	const key = params.get('key');

	$(function () {
		targetForm.submit(function () {
			const date1 = $('input[name="date1"]').val();
			const date2 = $('input[name="date2"]').val();
			const lastName = $('input[name="lastName"]').val();
			const firstName = $('input[name="firstName"]').val();
			const tel = $('input[name="tel"]').val();
			const model  = $('input[name="model"]').val();
			const service  = $('input[name="service"]:checked').val();
			const serviceOther  = $('input[name="serviceOther"]').val();
			const detail  = $('textarea[name="detail"]').val();
			const msg = `[作業希望日①]${date1}\n[作業希望日②]${date2}\n[お名前]${lastName} ${firstName}\n[電話番号]${tel}\n[車種名]${model}\n[希望サービス]${service}\n${serviceOther}\n[備考]${detail}`;
			sendText(msg);
			return false;
		});
	});	
})();

// カレンダースライダー
const calendarSlider = (() => {
	const target = '.js-calendarSlider';
	const targetElem = document.querySelector(target);
	if(!targetElem) return;
	
	const slides = targetElem.querySelectorAll('.swiper-slide');
	if(slides.length <= 1) {
		targetElem.classList.add('is-arrow-none');
	} else {
		const slider = new Swiper(target, {
			// loop:true,
			navigation: {
				nextEl: '.calendar-slider__arrow--next',
				prevEl: '.calendar-slider__arrow--prev',
			},
		});
	}
})();